var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureStreamlineIconTagsFavoriteStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.348,
    height: 64.086,
    viewBox: "0 0 62.348 64.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-tags-favorite-star_64x64",
    "data-name": "streamline-icon-tags-favorite-star@64x64",
    transform: "translate(-0.859 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M24.032,51.168a4,4,0,0,1-5.656,0L4.032,36.827a4,4,0,0,1,0-5.659l28-28A4,4,0,0,1,34.861,2H49.2a4,4,0,0,1,4,4V20.341a4,4,0,0,1-1.17,2.826",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M43.2,11a1,1,0,1,0,1,1,1,1,0,0,0-1-1h0",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M47,31.144,51.107,42h8a1.96,1.96,0,0,1,1.384,3.421l-6.933,4.84L57.405,59.1a2.1,2.1,0,0,1-2.984,2.619l-9.3-5.229-9.309,5.229A2.1,2.1,0,0,1,32.829,59.1l3.848-8.837-6.933-4.84A1.957,1.957,0,0,1,31.117,42h8l4.12-10.853a2.133,2.133,0,0,1,3.76,0Z",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureStreamlineIconTagsFavoriteStar);
export default __webpack_public_path__ + "static/media/feature-streamline-icon-tags-favorite-star.c740fa2d.svg";
export { ForwardRef as ReactComponent };